"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Stars = void 0;

var _react = _interopRequireDefault(require("react"));

require("@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/label.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/table.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

require('../style/styles.css');

/**
 * Render the rating stars.
 */
var Stars =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Stars, _React$Component);

  function Stars(props) {
    var _this;

    _classCallCheck(this, Stars);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stars).call(this, props)); // Set up the component. Since we show and hide elements, touch devices
    // will resort to "double touching" (read more about it here:
    // https://humanwhocodes.com/blog/2012/07/05/ios-has-a-hover-problem/).
    // As previously just the classes changed, this wasn't a problem. With
    // Semantic UI 2.4 and the combined icons, it is. Therefore we need to
    // take precautions and only attach the events that are appropriate to
    // the device. I do hope that this doesn't break on Windows with touch
    // screens, but this is a possibility.

    _this.onMouseLeave = function (event) {
      event.stopPropagation();
      event.preventDefault();

      _this.setState({
        activeStar: -1
      });
    };

    _this.onMouseEnter = function (event) {
      event.stopPropagation();
      event.preventDefault();

      _this.setState({
        activeStar: event.currentTarget.getAttribute('data-starIterationCount')
      });
    };

    if ('ontouchstart' in window.document.documentElement) {
      _this.state = {
        activeStar: -1,
        events: {
          onTouchStart: _this.props.clickHandler
        }
      };
    } else {
      _this.state = {
        activeStar: -1,
        events: {
          onClick: _this.props.clickHandler,
          onMouseEnter: _this.onMouseEnter,
          onMouseLeave: _this.onMouseLeave
        }
      };
    }

    return _this;
  }

  _createClass(Stars, [{
    key: "render",
    value: function render() {
      var starArray = [];
      var additionalHalfStar = false;
      var floorStars = 0; // Check if rating contains half stars or not

      if (this.props.averageRating >= 1) {
        floorStars = parseInt(Math.floor(this.props.averageRating));

        if (this.props.averageRating - floorStars >= 0.25 && this.props.averageRating - floorStars <= 0.75) {
          additionalHalfStar = true;
        }

        if (this.props.averageRating - floorStars >= 0.75) {
          floorStars = floorStars + 1;
        }
      } // Check if rating is set from Question component and also check for
      // MouseOver


      for (var i = 0; i < this.props.starAmount; i++) {
        var starClass = 'invisible';

        if (this.state.activeStar >= i || this.props.rating >= i) {
          starClass = '';
        }

        if (this.props.votingIsOver) {
          starClass = 'over';

          if (floorStars <= i) {
            starClass = 'invisible';

            if (additionalHalfStar && i === floorStars) {
              starClass = 'over half';
            }
          }
        } // FIXME Remove data attributes and replace with passing function
        //  parameters


        starArray.push(_react.default.createElement("i", _extends({
          className: "ui icons",
          key: "star-".concat(i),
          "data-starNumber": i + 1,
          "data-starIterationCount": i
        }, this.state.events), ' ', _react.default.createElement("i", {
          className: "icon ".concat(starClass, " ").concat(this.props.starIcon, " ").concat(this.props.starColor),
          style: {
            color: this.props.starColor.indexOf('#') === 0 ? this.props.starColor : ''
          }
        }), _react.default.createElement("i", {
          className: "outline ".concat(this.props.starIcon, " ").concat(this.props.starColor, " icon"),
          style: {
            color: this.props.starColor.indexOf('#') === 0 ? this.props.starColor : ''
          }
        }), ' '));
      }

      return _react.default.createElement("div", {
        className: "stars ".concat(this.props.className)
      }, starArray, ' ', this.props.votingIsOver && this.props.averageRating && _react.default.createElement("p", {
        className: "ui big label average ".concat(this.props.theme === 'simple' ? 'simple' : '', " ").concat(this.props.inverted ? 'inverted' : ''),
        style: {
          color: this.props.fontColor,
          fontFamily: 'Benton Sans Cond'
        }
      }, _react.default.createElement("span", {
        className: "average label"
      }, "\xD8", ' ', (Math.round(this.props.averageRating * 10) / 10).toFixed(1).toString().replace('.', ','))));
    }
  }]);

  return Stars;
}(_react.default.Component);

exports.Stars = Stars;
var _default = Stars;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-user-feedback/dist/stars.js
// module id = 451
// module chunks = 0